import { parseRarityName } from '$lib/utils';
import { faCalendarDays, faLock, faStars } from '@fortawesome/pro-solid-svg-icons';

import isDarkColor from 'is-dark-color';

export default (data) => {
  const baseUrl = '/skins/collectibles';
  const itemLink = (item) => `${baseUrl}/${item.slug}`;

  return {
    relationKey: 'collectible',
    relationItem: data.item.collectible,
    content: {
      stickyBox: {
        subtitle: `${parseRarityName(data.item.rarity)} Collectible`,
        title: data.item.name,
        link: { label: `Other Collectibles`, href: baseUrl },
      },
      priceFetcher: (item) => item.collectible.steamValue,
      infoBoxes: [
        {
          icon: faStars,
          label: 'Rarity',
          value: parseRarityName(data.item.rarity),
          style: `--col-rarity:${data.item.rarity.hexColor}`,
          modifiers: ['rarity', data.item.rarity.slug].concat(!isDarkColor(data.item.rarity.hexColor) ? ['dark'] : []),
        },
      ],
    },
  };
};
